import { render, staticRenderFns } from "./TraxAccountGroupCrudSearch.vue?vue&type=template&id=196719a3"
import script from "./TraxAccountGroupCrudSearch.vue?vue&type=script&lang=js"
export * from "./TraxAccountGroupCrudSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports